import React, { useEffect, useState } from "react";
import axios from "axios";
import { alert_error } from "../../AppContext.js";

const Admin_referrals = () => {
    const [data, set_data] = useState([]);
    const [is_loading, set_is_loading] = useState(true);
    const [error_message, set_error_message] = useState("");
    const [username_ref, set_username_ref] = useState("");
    const [iduser_ref, set_iduser_ref] = useState("");
    const [username, set_username] = useState("");
    const [id_users, set_id_users] = useState("");

    const fetchData = (event) => {
        if (event?.key && event.key !== "Enter") return;

        set_is_loading(true);
        set_error_message("");

        axios
            .get(
                `https://hust.media/hustadmin_v2/referrals_list.php?iduser_ref=${encodeURIComponent(
                    iduser_ref
                )}&username_ref=${encodeURIComponent(
                    username_ref
                )}&id_users=${encodeURIComponent(
                    id_users
                )}&username=${encodeURIComponent(username)}`
            )
            .then((response) => {
                if (Array.isArray(response.data)) {
                    set_data(response.data);
                } else {
                    set_data([]);
                }
            })
            .catch((error) => {
                alert_error(error);
                set_error_message("Không tải được dữ liệu referrals.");
                set_data([]);
            })
            .finally(() => {
                set_is_loading(false);
            });
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div className="max-w-6xl mx-auto">
            <div className="mt-2 mx-2 grid grid-cols-1">
                <div className="bg-white text-black p-3 rounded-md shadow-md md:col-span-2 dark:bg-slate-800 dark:text-white">
                    <div className="flex items-center justify-between gap-2">
                        <div className="text-lg font-semibold">Quản trị giới thiệu</div>
                        <button
                            onClick={fetchData}
                            className="px-3 py-1 rounded-md border-2 border-black dark:border-white"
                        >
                            Reload
                        </button>
                    </div>

                    <div className="mt-3 flex">
                        <input
                            type="text"
                            placeholder="username_ref"
                            value={username_ref}
                            onChange={(e) => set_username_ref(e.target.value)}
                            onKeyPress={fetchData}
                        />
                        <button className="mr-2" onClick={() => fetchData()}>
                            search
                        </button>
                        <input
                            type="text"
                            placeholder="iduser_ref"
                            value={iduser_ref}
                            onChange={(e) => set_iduser_ref(e.target.value)}
                            onKeyPress={fetchData}
                        />
                        <button className="mr-2" onClick={() => fetchData()}>
                            search
                        </button>
                        <input
                            type="text"
                            placeholder="username"
                            value={username}
                            onChange={(e) => set_username(e.target.value)}
                            onKeyPress={fetchData}
                        />
                        <button className="mr-2" onClick={() => fetchData()}>
                            search
                        </button>
                        <input
                            type="text"
                            placeholder="id_users"
                            value={id_users}
                            onChange={(e) => set_id_users(e.target.value)}
                            onKeyPress={fetchData}
                        />
                        <button className="mr-2" onClick={() => fetchData()}>
                            search
                        </button>
                    </div>

                    {is_loading && (
                        <div className="mt-3 text-center">Đang tải dữ liệu...</div>
                    )}

                    {!is_loading && error_message && (
                        <div className="mt-3 text-center text-red-600">{error_message}</div>
                    )}

                    {!is_loading && !error_message && (
                        <>
                            <div className="mt-2 text-sm opacity-80">
                                Tổng: {data.length}
                            </div>

                            <div className="table-responsive-sm mt-2">
                                <table className="table-auto w-full border-collapse">
                                    <thead className="bg-slate-700 text-white">
                                        <tr>
                                            <th className="border text-center py-2">id</th>
                                            <th className="border text-center py-2">iduser</th>
                                            <th className="border text-center py-2">username</th>
                                            <th className="border text-center py-2">device_type</th>
                                            <th className="border text-center py-2">device_id</th>
                                            <th className="border text-center py-2">createdate</th>
                                            <th className="border text-center py-2">total_nap</th>
                                            <th className="border text-center py-2">jop_earn_week</th>
                                            <th className="border text-center py-2">referrer_id</th>
                                            <th className="border text-center py-2">referrer_username</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.map((row) => (
                                            <tr key={row.id}>
                                                <td className="border text-center py-2 break-all">
                                                    {row.id}
                                                </td>
                                                <td className="border text-center py-2 break-all">
                                                    {row.iduser}
                                                </td>
                                                <td className="border text-center py-2 break-all">
                                                    <b>{row.username}</b>
                                                </td>
                                                <td className="border text-center py-2 break-all">
                                                    {row.device_type}
                                                </td>
                                                <td className="border text-center py-2 break-all">
                                                    {row.device_id}
                                                </td>
                                                <td className="border text-center py-2 break-all">
                                                    {row.createdate}
                                                </td>
                                                <td className="border text-center py-2 break-all">
                                                    {row.total_nap}
                                                </td>
                                                <td className="border text-center py-2 break-all">
                                                    {row.jop_earn_week}
                                                </td>
                                                <td className="border text-center py-2 break-all">
                                                    {row.referrer_id}
                                                </td>
                                                <td className="border text-center py-2 break-all">
                                                    {row.referrer_username}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                {data.length === 0 && (
                                    <div className="mt-3 text-center">
                                        Không có dữ liệu.
                                    </div>
                                )}
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Admin_referrals;
